import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';
import Loader from '../layout/Loader';

const PrivateRoute = () => {
    const { userInfo } = useSelector((state) => state.auth);

    // 🔄 Wait for Redux to hydrate
    if (userInfo === undefined) return <Loader />;

    return userInfo ? <Outlet /> : <Navigate to="/login" replace />;
};

export default PrivateRoute;
